import { set, toggle, reactiveSetArray } from '@shopworx/services/util/store.helper';

export default ({
  namespaced: true,
  state: {
    loading: false,
    drawer: false,
    downtimeLoading: false,
    lastRefreshedAt: null,
    thisShift: null,
    thisDate: null,
    currentShift: null,
    currentDate: null,
    shifts: [],
    machines: [],
    machinesrecord: [],
    shiftAvailabletime: [],
    downtimeList: [],
    downtimeByMachine: null,
    cycleTime: null,
  },
  mutations: {
    setLoading: set('loading'),
    setDrawer: set('drawer'),
    toggleDrawer: toggle('drawer'),
    setDowntimeLoading: set('downtimeLoading'),
    setLastRefreshedAt: set('lastRefreshedAt'),
    setThisShift: set('thisShift'),
    setThisDate: set('thisDate'),
    setCurrentShift: set('currentShift'),
    setCurrentDate: set('currentDate'),
    setShifts: set('shifts'),
    setMachine: reactiveSetArray('machines'),
    setDowntimeList: set('downtimeList'),
    setDowntimeByMachine: set('downtimeByMachine'),
    setCycleTimeAnalysis: set('cycleTime'),
  },
  actions: {
    getShifts: async ({ commit, dispatch }) => {
      const records = await dispatch(
        'element/getRecords',
        {
          elementName: 'businesshours',
          query: '?sortquery=sortindex==1',
        },
        { root: true },
      );
      if (records && records.length) {
        commit('setShifts', records);
        return true;
      }
      return false;
    },

    getBusinessTime: async ({ commit, dispatch }) => {
      const data = await dispatch(
        'calendar/getBusinessTime',
        null,
        { root: true },
      );
      if (data) {
        commit('setCurrentShift', data.shiftName);
        commit('setCurrentDate', +data.date);
        return true;
      }
      return false;
    },

    getDashboardData: async ({ commit, dispatch }) => {
      commit('setLoading', true);
      // await dispatch('getShiftAvailableTime');
      await Promise.all([
        // dispatch('getThisShfitSummary'),
        dispatch('getDowntimeByMachine'),
        dispatch('getGetCycleTime'),
      ]);
      commit('setLastRefreshedAt', new Date().toLocaleTimeString('en-GB'));
      commit('setLoading', false);
    },

    getDowntimeByMachine: async ({
      commit,
      dispatch,
      state,
      rootState,
    }) => {
      const { activeSite } = rootState.user;
      const { thisDate, thisShift } = state;
      const date = parseInt(thisDate.replace(/-/g, ''), 10);
      const data = await dispatch(
        'report/executeReport',
        {
          reportName: 'shiftdowntimebymachine',
          payload: {
            siteid: activeSite,
            dateVal: date,
            shiftVal: thisShift,
          },
        },
        { root: true },
      );
      if (data) {
        const { chartOptions } = JSON.parse(data);
        commit('setDowntimeByMachine', chartOptions);
      } else {
        commit('setDowntimeByMachine', null);
      }
    },
    getGetCycleTime: async (
      {
        commit, dispatch, state, rootState,
      },
    ) => {
      const { activeSite } = rootState.user;
      const { thisDate, thisShift } = state;
      const date = parseInt(thisDate.replace(/-/g, ''), 10);

      const data = await dispatch(
        'report/executeReport',
        {
          reportName: 'shiftliveshopfloor',
          payload: {
            siteid: activeSite,
            dateVal: date,
            shiftVal: thisShift,
          },
        },
        { root: true },
      );

      if (data) {
        const rowData = JSON.parse(data);
        const sortedMachines = rowData.machines
          .map((m) => ({
            name: m.machinename,
            runtime: +(m.runtime / 60000).toFixed(2),
          }))
          .filter((m) => m.runtime > 0)
          .sort((a, b) => b.runtime - a.runtime);

        const categories = sortedMachines.map((m) => m.name);
        const runtimeInMinutes = sortedMachines.map((m) => m.runtime);

        const chartOptions = {
          title: {
            text: 'Cycletime By Machine',
            style: { color: '#333333' },
          },
          chart: { type: 'column' },
          tooltip: { shared: true },
          yAxis: [
            {
              title: { text: 'Cycletime  (in mins)' },
              gridLineWidth: 0,
            },
            {
              title: { text: 'Contribution %' },
              gridLineWidth: 0,
              minPadding: 0,
              maxPadding: 0,
              max: 100,
              min: 0,
              opposite: true,
              labels: { format: '{value}%' },
            },
          ],
          xAxis: {
            categories,
            crosshair: true,
            gridLineWidth: 0,
            labels: { style: { color: '#666666' } },
          },
          series: [
            {
              type: 'pareto',
              showInLegend: false,
              name: 'Pareto',
              color: '#063d90',
              yAxis: 1,
              zIndex: 10,
              baseSeries: 1,
              tooltip: { valueDecimals: 2, valueSuffix: '%' },
            },
            {
              name: 'Cycletime  (in mins)',
              type: 'column',
              color: '#7cb5ec',
              showInLegend: false,
              zIndex: 2,
              data: runtimeInMinutes,
            },
          ],
        };

        commit('setCycleTimeAnalysis', chartOptions);
      } else {
        commit('setCycleTimeAnalysis', null);
      }
    },
  },
  getters: {
    shiftList: ({ shifts }) => {
      let shiftList = [];
      if (shifts && shifts.length) {
        const allShifts = shifts.filter((rec) => rec.type === 'shift');
        shiftList = [...new Set(allShifts.map((item) => item.name))];
      }
      return shiftList;
    },

    getHourStart: (
      { thisDate },
    ) => (displayHour) => {
      const [start] = displayHour.split('-');
      const [hr, min] = start.split(':');
      const [year, month, day] = thisDate.split('-');
      return new Date(year, month - 1, day, parseInt(hr, 10), parseInt(min, 10), 0).getTime();
    },

    downtime: ({ downtimeList, machinesrecord }) => {
      let downtime = null;
      let sequenceWiseDowntimeData = null;
      if (downtimeList && downtimeList.length) {
        downtime = downtimeList
          .reduce((result, currentValue) => {
            const key = currentValue.machinename;
            if (!result[key]) {
              // eslint-disable-next-line
              result[key] = {};
              // eslint-disable-next-line
              result[key].values = [];
            }
            // eslint-disable-next-line
            result[key].values = [
              ...result[key].values,
              currentValue,
            ];
            return result;
          }, {});
      }
      if (!downtime || !Object.keys(downtime).length) {
        downtime = null;
      }
      if (downtime !== null && machinesrecord && machinesrecord.length) {
        const sequenceDowntime = [];
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < Object.keys(downtime).length; index++) {
          const obj = Object.keys(downtime)[index];
          const findMachine = machinesrecord.find((ele) => ele.machinename === obj);
          if (findMachine) {
            const sequence = findMachine.sequence && findMachine.sequence > 0
              ? findMachine.sequence - 1
              : findMachine.sequence;
            sequenceDowntime.push({ [sequence]: obj });
          }
        }
        if (sequenceDowntime && sequenceDowntime.length) {
          sequenceDowntime.sort((a, b) => {
            const keyA = Object.keys(a)[0];
            const keyB = Object.keys(b)[0];
            return keyA - keyB;
          });
          const data = [];
          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < sequenceDowntime.length; index++) {
            const obj = sequenceDowntime[index];
            const downtimeData = Object.keys(downtime).findIndex((ele) => ele
            === Object.values(obj)[0]);
            data.push({ [Object.values(obj)[0]]: Object.values(downtime)[downtimeData] });
          }
          sequenceWiseDowntimeData = Object.assign({}, ...data);
        }
      }
      if (!sequenceWiseDowntimeData || !Object.keys(sequenceWiseDowntimeData).length) {
        sequenceWiseDowntimeData = null;
      }
      return sequenceWiseDowntimeData;
    },

    filteredMachines: ({ machines }, _, __, rootGetters) => rootGetters['webApp/filteredRecords'](machines),
  },
});
